<article [innerHTML]="pagina$ | async | markdown">
</article>
